import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-8 w-8 bg-foreground grid place-items-center rounded-sm">
              <span className="text-background font-heading font-extrabold text-sm">ER</span>
            </div>
            <span className="font-heading font-bold text-xl">ExactReach</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">
            Targeted B2B data on demand. Pay only for what you need.
          </p>
        </div>
        <div>
          <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/how-it-works" className="hover:underline">How It Works</Link></li>
            <li><Link to="/why-choose-us" className="hover:underline">Why ExactReach</Link></li>
            <li><Link to="/pricing" className="hover:underline">Pricing</Link></li>
            <li><Link to="/faq" className="hover:underline">FAQ</Link></li>
            <li><Link to="/about" className="hover:underline" data-testid="footer-about">About</Link></li>
            <li><Link to="/contact" className="hover:underline">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/terms" className="hover:underline" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/legal/privacy" className="hover:underline" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/legal/data" className="hover:underline">Data Policy</Link></li>
            <li><Link to="/legal/aup" className="hover:underline">Acceptable Use</Link></li>
            <li><Link to="/legal/cookies" className="hover:underline">Cookie Policy</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-4">Company</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>ExactReach Ltd.</li>
            <li>support@exactreach.example</li>
            <li>Mon–Fri, 9:00 – 18:00 GMT</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} ExactReach. All rights reserved.</div>
          <div className="font-mono">v1.0 · demo build</div>
        </div>
      </div>
    </footer>
  );
}
